import { Box } from '@mui/material';
import { IconEdit } from 'assets/img';
import { LwButton, Toolbox } from 'redesign';
import { useCompanyRelativePath } from 'ogp/hooks';
import { routes } from 'ogp/Routes';
import { useTranslation } from 'react-i18next';

export const SettingsDetailToolbox = () => {
  const generatePath = useCompanyRelativePath();
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Toolbox>
      <Toolbox.PushRight>
        <Box position="absolute" right="32px" top={'32px'}>
          <LwButton
            to={generatePath(routes.SettingsEdit)}
            startIcon={<IconEdit />}
            color="primary"
            iconColorMode="fill"
          >
            {t('settings-detail.edit-button')}
          </LwButton>
        </Box>
      </Toolbox.PushRight>
    </Toolbox>
  );
};
